const data = [
    {
      "no": "13",
      "name": "Reisling",
      "image": "reisling.png",
      "cost": {
        "bottle": 17.9,
        "case": 204.9
      },
      "tags": ["white", "vintage"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "14",
      "name": "Breidecker",
      "image": "breidecker.jpg",
      "cost": {
        "bottle": 24.35,
        "case": 300.88
      },
      "tags": ["red"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "15",
      "name": "Chardonnay",
      "image": "chardonnay.png",
      "cost": {
        "bottle": 12.23,
        "case": 134.45
      },
      "tags": ["sparkling"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "16",
      "name": "Hukupapa",
      "image": "hukupapa.png",
      "cost": {
        "bottle": 55.5,
        "case": 500.0
      },
      "tags": ["white", "vintage"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "17",
      "name": "Hunters Gewurztraminer",
      "image": "hunters_gewurztraminer.png",
      "cost": {
        "bottle": 5.5,
        "case": 50.0
      },
      "tags": ["white", "vintage"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "18",
      "name": "Hunters Late Harvest Sauvignon-Blanc",
      "image": "Hunters_Late_Harvest_Sauvignon-Blanc.png",
      "cost": {
        "bottle": 22.35,
        "case": 198.0
      },
      "tags": ["white"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "19",
      "name": "Hunters Mirumiru Non Vintage",
      "image": "hunters_mirumiru_non_vintage.png",
      "cost": {
        "bottle": 12.5,
        "case": 98.5
      },
      "tags": ["red"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    },
    {
      "no": "20",
      "name": "Pinot Noir",
      "image": "pinotnoir.png",
      "cost": {
        "bottle": 56.5,
        "case": 630.0
      },
      "tags": ["red", "vintage"],
      "details": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus mollis eget lorem nec placerat. Morbi sed sapien eu lorem eleifend elementum. Donec scelerisque, odio quis placerat tempor, eros dui feugiat."
    }
  ]

  export default data